<template>
  <vuestic-widget header-text="Listado Ventas con Deposito">
    <div class="filtros">
      <div class="form-group">
        <div class="input-group mr-1">
          <input-comp label="Folio" v-model="filtros.folioVenta" />
        </div>
        <div class="input-group mr-1">
          <label for="desde">Desde</label>
          <input type="date" id="desde" v-model="filtros.fechaInicial" />
          <i class="bar"></i>
        </div>
        <div class="input-group mr-1">
          <label for="hasta">Hasta</label>
          <input  type="date" id="hasta" v-model="filtros.fechaFinal" />
          <i class="bar"></i>
        </div>
        <div class="input-group mr-1">
          <label for="banco">Banco</label>
          <select id="banco" v-model="filtros.banco">
            <option value="">Seleccione...</option>
            <option value="pendiente">Pendiente</option>
            <option v-for="banco in bancos" >{{banco}}</option>
          </select>
          <i class="bar"></i>
        </div>
        <div class="input-group mr-1">
          <input-comp label="Código Interno" v-model="filtros.codigoDeposito" />
        </div>
      </div>
      <button type="button" class="btn btn-info btn-micro" @click="filtrar">Filtrar</button>
    </div>
    <br>
    <table class="table table-bordered">
      <thead class="thead-light">
      <tr>
        <th>Tipo</th>
        <th>Folio</th>
        <th>Cód.Interno</th>
        <th>Fecha</th>
        <th>Vendedor</th>
        <th>Cliente</th>
        <th>Sucursal</th>
        <th>Banco</th>
        <th>Desposito</th>
        <th>Total</th>
        <th>Estado</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="deposito in registros">
        <td>{{ deposito.type.toUpperCase() }}</td>
        <td>{{ deposito.folio }}</td>
        <td>{{ deposito.detalle_pago.deposito.codigo_interno || 0}}</td>
        <td>{{ deposito.created_at | date}}</td>
        <td>{{ deposito.vendedor_nombre | upper}}</td>
        <td>{{ deposito.cliente_nombre | upper }}</td>
        <td>{{ deposito.sucursal_nombre | upper}}</td>
        <td>{{deposito.detalle_pago.deposito.banco}}</td>
        <td align="right">${{ parseInt(deposito.detalle_pago.deposito.monto).toLocaleString() }}</td>
        <td align="right">${{ parseInt(deposito.total).toLocaleString() }}</td>
        <td>{{deposito.estado.toUpperCase() }}</td>
      </tr>
      </tbody>
    </table>
    <div class="btn-group-sm">
      <button class="btn btn-info btn-micro" @click="paginar(-1)">Anterior</button>
      {{paginaActual}}
      <button class="btn btn-info btn-micro" @click="paginar(1)">Siguiente</button>
    </div>
  </vuestic-widget>
</template>
<script>
  import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import InputComp from "../../Componentes_Globales/Input/inputComp";
  import bancos   from '../../Caja/js/bancos'
  import moment from 'moment'
  import {URL_SERVER} from "../../../api/config";
  import {DEPOSITOS} from "../routes";
  export default  {
    name: 'listaDepositos',
    components: {InputComp, VuesticWidget},
    created() {
      this.loadInitialData()
    },
    methods: {
      paginar(direccion) {
        if (direccion === -1 && this.paginaActual === 1) {
          return this.paginaActual = 1
        }
        this.paginaActual += direccion
        this.loadInitialData()
      },
      async loadInitialData() {
        this.$axios.get(URL_SERVER + DEPOSITOS + this.generarQuery()).then(({ data }) => this.registros = data.items)
      },
      filtrar() {
        this.paginaActual = 1
        this.loadInitialData()
      },
      generarQuery() {
        const filtros = {...this.filtros}
        const query = "?" + Object.keys(filtros).filter(key => filtros[key] !== "").map(key => {
          let value = filtros[key]
          if (key === 'offset') {
            value = (this.paginaActual - 1) * this.filtros.limite;
          }
          return encodeURI(`${key}=${value}`)
        }).join("&")
        console.log(query)
        return query
      }
    },
    data() {
      return {
        registros: [],
        filtros: {
          limite: 30,
          offset: 0
        },
        bancos,
        paginaActual: 1
      }
    },
    filters: {
      upper: function(value){
        value = value.toString()
        return value.toUpperCase()
      },
      date: function(value) {
        return moment(value).format("DD/MM/YYYY hh:mm:ss")
      }
    }
  }
</script>
